import { configurationsPiletModals } from '@sharefiledev/configurations-pilet-sdk';
import { type PiletApi } from '@sharefiledev/sharefile-appshell';
import { addBlocks } from './blocks';
import { configureDominoApiClient } from './clients/domino/dominoClient';
import { getDefaultModalOptions } from './components/EditSettingsTabs/getDefaultModalOptions';
import { addBlockDevelopment } from './development';
import { EditSettings } from './extensions/EditSettings';
import { EditSettingsTabs } from './extensions/EditSettingsTabs';
import { EditSettingsTabsModal } from './modals/EditSettingsTabsModal';

const smokeTestCustomers = [
	'configurationspilet.sharefiletest.com',
	'configurationspilet.sharefilestaging.com',
	'configurationspilet.sharefile.com',
];

export function setup(piral: PiletApi) {
	(window as any).SF_configurationspiletexecuted = true;

	addBlocks(piral);

	configureDominoApiClient(piral);

	piral.registerExtension('urn:sfextslot:configurations-pilet:edit-settings', props => (
		<EditSettings {...props} />
	));

	piral.registerExtension(
		'urn:sfextslot:configurations-pilet:edit-settings-tabs',
		props => <EditSettingsTabs {...props} />
	);

	piral.registerModal(
		configurationsPiletModals.editSettingsTabs,
		({ options, cancelInteraction, completeInteraction }) => (
			<EditSettingsTabsModal
				piral={piral}
				completeInteraction={completeInteraction}
				cancelInteraction={cancelInteraction}
				containerRid={options?.containerRid!}
				contextRid={options?.contextRid!}
			/>
		),
		getDefaultModalOptions()
	);

	if (
		process.env.NODE_ENV === 'development' ||
		smokeTestCustomers.includes(location.hostname)
	) {
		addBlockDevelopment(piral);

		if (typeof piral.meta.config.apiOrigin === 'string') {
			/**
			 * Manual require ensures tree-shaking
			 * does not include these modules in the entry index.js
			 */
			const { Configuration } = require('./generated/runtime');
			const { configureHttp } = require('./httpConfiguration');
			configureHttp((config: any) => {
				config.config = new Configuration({
					basePath: `${piral.meta.config.apiOrigin}/io/configurations`,
				});
			});
		}
	}
}
